import { useState } from 'react';
import { faqList } from '@/mocks/faq';

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="bg-background-100/70 border-t border-background-200/70">
      <div className="mx-auto max-w-3xl px-4 md:px-6 py-14 md:py-18">
        <div className="text-center mb-8">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-accent-700">
            <i className="ri-question-line" />
            常见问题
          </span>
          <h2 className="mt-1 font-heading text-2xl md:text-3xl font-bold text-foreground-950">你可能想知道的</h2>
          <p className="mt-2 text-sm text-foreground-600">关于角色百科、声优表与资料整理的常见疑问</p>
        </div>

        <div className="space-y-3">
          {faqList.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="overflow-hidden rounded-xl border border-background-200/70 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm md:text-base font-medium text-foreground-950">{item.question}</h3>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-800 transition-transform ${isOpen ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line" />
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-4 text-sm leading-6 text-foreground-600">{item.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}